var render = function () {
  var _vm$meeting, _vm$schedule, _vm$meeting2, _vm$meeting2$company;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    staticClass: "fill-height",
    attrs: {
      "value": _vm.tabValue
    }
  }, [_c('v-layout', {
    staticStyle: {
      "overflow-y": "hidden"
    },
    attrs: {
      "column": "",
      "justify-center": "",
      "align-center": "",
      "fill-height": ""
    }
  }, [_c('v-card-subtitle', [_c('v-chip', [_vm._v(_vm._s((_vm$meeting = _vm.meeting) === null || _vm$meeting === void 0 ? void 0 : _vm$meeting.title))])], 1), _c('v-card-title', [_vm._v("해당 미팅의 매칭이 완료되었습니다.")]), _c('v-card-subtitle', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v(" " + _vm._s((_vm$schedule = _vm.schedule) === null || _vm$schedule === void 0 ? void 0 : _vm$schedule.dateText) + " ")]), _vm._v(" 에 "), _c('br'), _c('span', {
    staticClass: "secondary--text"
  }, [_vm._v(_vm._s((_vm$meeting2 = _vm.meeting) === null || _vm$meeting2 === void 0 ? void 0 : (_vm$meeting2$company = _vm$meeting2.company) === null || _vm$meeting2$company === void 0 ? void 0 : _vm$meeting2$company.name))]), _vm._v(" 업체와 미팅 일정이 설정되었습니다. ")]), _c('v-card-actions', {
    staticClass: "justify-center"
  }, [_vm.editable ? _c('v-btn', {
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('prev');
      }
    }
  }, [_vm._v(" 미팅 일정 변경하기 ")]) : _vm._e(), _vm._t("tab-complete-actions")], 2)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }